import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsBrands = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path d="M1.2,14.7c1.2,3.9,4.2,7.1,8.1,8.4l.6.2V.4L1.2,14.5v.2ZM9,3.5v18.5c-3.3-1.3-5.8-4.1-6.8-7.4L9,3.5Z" />
        <path d="M22.8,9.3c-1.2-3.9-4.1-7.1-8-8.4l-.6-.2v22.9h0l8.7-14.1v-.2ZM15.1,20.4V2c3.2,1.3,5.7,4.1,6.8,7.4l-6.8,11Z" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsBrands;
